// The editor creator to use.
import InlineEditorBase from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor'

import List from '@ckeditor/ckeditor5-list/src/list'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript'
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript'
import Link from './ckeditor5-link/src/link'
import AutoLink from './ckeditor5-link/src/autolink'
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters'
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
// import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat'
import TodoList from '@ckeditor/ckeditor5-list/src/todolist'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock'
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation'
import Font from '@ckeditor/ckeditor5-font/src/fontcolor'
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock'
// import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'

export default class InlineEditor extends InlineEditorBase {}

// Plugins to include in the build.
InlineEditor.builtinPlugins = [
  // EssentialsPlugin,
  // AutoformatPlugin,
  Paragraph,
  PasteFromOffice,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  List,
  Link,
  AutoLink,
  Heading,
  SpecialCharacters,
  SpecialCharactersEssentials,
  // Alignment,
  Essentials,
  RemoveFormat,
  Indent,
  TodoList,
  IndentBlock,
  TextTransformation,
  Font,
  Highlight,
  HorizontalLine,
  BlockQuote,
  CodeBlock,
  // PageBreak,
]

InlineEditor.defaultConfig = {
  toolbar: {
    shouldNotGroupWhenFull: true,
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'subscript',
      'superscript',
      'removeFormat',
      'fontColor',
      'highlight',
      '|',
      'link',
      '|',
      //'alignment',
      'bulletedList',
      'numberedList',
      'todoList',
      'outdent',
      'indent',
      '|',
      'undo',
      'redo',
      '|',
      'specialCharacters',
      'horizontalLine',
      'blockQuote',
      '|',
      'codeBlock',
    ]
  },
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
      { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
    ]
  },
  typing: {
    transformations: {
      extra: [
        // { from: ':tada:', to: '🎉' }
      ]
    }
  },
  link: {
    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
    addTargetToExternalLinks: true,

    // Let the users control the "download" attribute of each link.
    decorators: [
      {
        mode: 'manual',
        label: 'Open in a new tab',
        defaultValue: true,
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer'
        },
      }
    ]
  },
  highlight: {
    options: [
      {
        model: 'yellowMarker',
        class: 'bg-yellow-200',
        title: 'Yellow marker',
        color: '#fef08a',
        type: 'marker'
      },
      {
        model: 'greenMarker',
        class: 'bg-green-200',
        title: 'Green marker',
        color: '#bbf7d0',
        type: 'marker'
      },
      {
        model: 'redPen',
        class: 'red-pen',
        title: 'Red text',
        color: '#dc2626',
        type: 'pen'
      }
    ]
  },
  // This value must be kept in sync with the language defined in webpack.config.js.
  language: 'en'
}
